import React from 'react'
import Reflux from 'reflux'
import Store from '../../store/store'
import {Link} from 'react-router-dom'
import Field from '../common/Field'
import Validator from '../common/Validator'
import api from '../../source/api'
import Alert from '../common/alert'
import 'react-phone-number-input/style.css'

class Signup extends Reflux.Component {

    constructor() {
        super()
        this.state = {
            fields: {
                email: {value: '', error: '', role: {required: true}},
                phone_number: {value: '', error: '', role: {required: true}},
                password: {value: '', error: '', role: {required: true}},
                password_confirmation: {value: '', error: '', role: {required: true}},
                first_name: {value: '', error: '', role: {required: true}},
                last_name: {value: '', error: '', role: {required: true}},
                company: {value: '', error: '', role: {required: true}},
                vatnumber: {value: '', error: '', role: {required: true}},
                postal_code: {value: '', error: '', role: {required: true}},
                city: {value: '', error: '', role: {required: true}},
                street: {value: '', error: '', role: {required: true}},
                street_nb: {value: '', error: '', role: {required: true}},
            },
            signupFeedback: {
                type: '',
                message: ''
            },
            error: false,
            loading: false,
            success: '',
            signupDone: false
        }
        this.store = Store
    }

    setValue = (name, value, error) => {
        this.resetErrorMessage()
        let fields = this.state.fields
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields})
    }

    signupUser = () => {
        let validator = Validator.validate(this.state.fields)
        if (validator.error) {
            this.setState({
                fields: validator.fields,
                error: validator.error
            })
            return;
        }

        if (this.state.fields.password.value != this.state.fields.password_confirmation.value) {
            this.setState({
                error: true
            })
            this.setMessage('Jelszó és jelszó megerősítés nem egyezik.', 'danger')
            return
        }

        let validPassword = /^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
        if (!this.state.error && !validPassword.test(this.state.fields.password.value)) {
            this.setState({
                error: true
            })
            this.setMessage('Jelszó minimum 8 karakter hosszú kell legyen, tartalmaznia kell legalább 1 nagybetűt és 1 számot és 1 speciális karaktert pl.: !@#$%^&*', 'danger')
            return
        }

        let validPostalCode = /^[0-9]{4}$/
        if (!this.state.error && !validPostalCode.test(this.state.fields.postal_code.value)) {
            this.setState({
                error: true
            })
            this.setMessage('Érvénytelen írányítószám. Elfogadott formátum: 1234', 'danger')
            return
        }

        let data = {
            email: this.state.fields.email.value,
            phone_number: this.state.fields.phone_number.value,
            first_name: this.state.fields.first_name.value,
            last_name: this.state.fields.last_name.value,
            password: this.state.fields.password.value,
            company: this.state.fields.company.value,
            vatnumber: this.state.fields.vatnumber.value,
            postal_code: this.state.fields.postal_code.value,
            city: this.state.fields.city.value,
            street: this.state.fields.street.value,
            street_nb: this.state.fields.street_nb.value,
        }
        api.post({url: 'auth/signup', data}).then((response) => {
            if (response.status == 200) {
                this.setState({signupDone: true})
                this.setMessage('Regisztráció sikeresen befejeződött. Kérünk ellenőrizd az email fiókodat és erősísd meg a regisztrációt.', 'success')
            }
        }).catch((error) => {
            if (error.response.status == 406) {
                this.setMessage('Sikertelen regisztráció, kérjük próbálja meg újból.', 'danger')
            } else if (error.response.status == 400) {
                this.setMessage('A megadott email címmel már korábban regisztráltak.', 'danger')
            } else this.setMessage('Sikertelen regisztráció, kérjük próbálja meg újból.', 'danger')
        })
    }

    setMessage = (msg, type) => {
        this.state.signupFeedback.type = type
        this.state.signupFeedback.message = msg
        this.setState({
            signupFeedback: {
                type: type,
                message: msg
            }
        })
    }

    resetErrorMessage = () => {
        this.setMessage('', '');
    }

    render() {
        return (
            <div className='container'>
                <div className="site-login">
                    <h1 className="offset-md-4 col-lg-4 text-center">Regisztráció</h1>
                    <p className="offset-md-4 col-lg-4 text-center">Kérünk tölse ki a lenti űrlapot:</p>
                    <div className="row">
                        <div className="col-lg-12">
                            {this.state.signupFeedback.type.length > 0 ? <Alert type={this.state.signupFeedback.type} message={this.state.signupFeedback.message}/> : ''}
                        </div>
                    </div>

                    <div className={!this.state.signupDone ? 'row' : 'd-none'}>

                        <div className="col-lg-4 offset-lg-2">
                            <Field
                                type="text"
                                id="signup-first_name"
                                name="first_name"
                                label="Vezetéknév"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="text"
                                id="signup-last_name"
                                name="last_name"
                                label="Személynév"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="email"
                                id="signup-email"
                                name="email"
                                label="Email cím"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="password"
                                id="signup-password"
                                name="password"
                                label="Jelszó"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="password"
                                id="signup-password_confirmation"
                                name="password_confirmation"
                                label="Jelszó megerősítés"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                        </div>

                        <div className="col-lg-4">
                            <Field
                                type="text"
                                id="signup-company"
                                name="company"
                                label="Cégnév"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <Field
                                type="text"
                                id="signup-vatnumber"
                                name="vatnumber"
                                label="Adószám"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <Field
                                        type="number"
                                        id="signup-postal_code"
                                        name="postal_code"
                                        label="Irányítószám"
                                        classLabel="control-label"
                                        classInput="form-control"
                                        setValue={this.setValue.bind(this)}
                                        state={this.state}
                                        style={{width: '100%'}}
                                    />
                                </div>
                                <div className='col-lg-6'>
                                    <Field
                                        type="text"
                                        id="signup-phone_number"
                                        name="phone_number"
                                        label="Telefonszám"
                                        classLabel="control-label"
                                        classInput="form-control"
                                        setValue={this.setValue.bind(this)}
                                        state={this.state}
                                        style={{width: '100%'}}
                                    />
                                </div>
                            </div>
                            <Field
                                type="text"
                                id="signup-city"
                                name="city"
                                label="Település"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue.bind(this)}
                                state={this.state}
                                style={{width: '100%'}}
                            />
                            <div className='row'>
                                <div className='col-lg-6'>
                                    <Field
                                        type="text"
                                        id="signup-street"
                                        name="street"
                                        label="Utca"
                                        classLabel="control-label"
                                        classInput="form-control"
                                        setValue={this.setValue.bind(this)}
                                        state={this.state}
                                        style={{width: '100%'}}
                                    />
                                </div>
                                <div className='col-lg-6'>
                                    <Field
                                        type="text"
                                        id="signup-street_nb"
                                        name="street_nb"
                                        label="Házszám"
                                        classLabel="control-label"
                                        classInput="form-control"
                                        setValue={this.setValue.bind(this)}
                                        state={this.state}
                                        style={{width: '100%'}}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className={!this.state.signupDone ? 'row' : 'd-none'}>
                        <div className="col-lg-12">
                            <br/>
                            <br/>
                            <div className="text-center">
                                <button type="submit" onClick={() => this.signupUser()} className="btn green-btn" name="login-button">Regisztráció</button>
                                <br/>
                                <br/>
                                <Link to="/login"> Bejelentkezés </Link>
                                <br/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Signup


// WEBPACK FOOTER //
// ./src/components/signup/signup.js